import Vue from 'vue'
import Router from 'vue-router'
import { auth } from './auth'
import Main from './views/Main.vue'
import Login from './views/auth/Login.vue'
import Session from './views/auth/Session.vue'
import Dashboard from './views/Dashboard.vue'
import RouteOverview from './views/RouteOverview.vue'
import RouteComments from './views/RouteComments.vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: Main,
            meta: {
                title: 'Trafiki',
            },
            children: [
                {
                    path: 'login',
                    name: 'login',
                    component: Login,
                },
                {
                    path: 'login/session',
                    name: 'session',
                    component: Session,
                },
                {
                    path: '',
                    component: Main,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: '',
                            name: 'dashboard',
                            component: Dashboard,
                        },
                        {
                            path: '/routes/:id',
                            name: 'route',
                            component: RouteOverview,
                            meta: {
                                title: 'Trafiki - Route #:id',
                            },
                        },
                        {
                            path: '/routes/:id/comments',
                            name: 'routeComments',
                            component: RouteComments,
                            meta: {
                                title: 'Trafiki - Route Comments #:id',
                            },
                        },
                    ],
                },
            ],
        },
    ],
})

router.beforeEach((to, _from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (auth.getToken() == null) {
            return next({ name: 'login' })
        }
    }
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = [...to.matched]
        .reverse()
        .find((r) => r.meta != null && r.meta.title != null)

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle != null) {
        document.title = Object.entries(to.params).reduce(
            (title, [key, value]) => title.replace(`:${key}`, value),
            nearestWithTitle.meta.title,
        )
    }

    return next()
})

export default router
